import 'react-multi-carousel/lib/styles.css';
import { Link, navigate } from 'gatsby';
import coreuiCss from '!raw-loader!../layout/coreui.css';
import { graphql, PageProps } from 'gatsby';
import React from 'react';
import Helmet from 'react-helmet';
import ReactTooltip from 'react-tooltip';
import { api } from '../lib/api';
import { getWithExpiry, setWithExpiry } from '../lib/local-storage-with-expiry';

import { BackgroundOverlay } from '../components/BackgroundOverlay/BackgroundOverlay';
import { BackgroundVideo } from '../components/BackgroundVideo/BackgroundVideo';
import Button, { EButtonType } from '../components/Button';
import { Text } from '../components/Text/Text';
import Banner from '../images/fotos/banner2.jpg';
import backgroundImg from '../images/fotos/RepeatBg.png';
import Layout from '../layout';
import { mq } from '../theme';

type ContactFormState = {
  contact: {
    voornaam: string;
    achternaam: string;
    postcode: string;
    huisnummer: string;
    toevoeging: string;
    bedrijfsnaam: string;
    emailadres: string;
    telefoonnummer: string;
    huidigProvider: string;
    hoeGehoord: string;
    internetDuur: string;
    bericht: string;
  };
  validated: boolean;
  loading: boolean;
};

class CompanyFormPage extends React.PureComponent<PageProps<{}>, ContactFormState> {
  sessionOrder: any;

  constructor(props: any) {
    super(props);

    this.sessionOrder = getWithExpiry('order') || {};
    this.state = {
      contact: {
        voornaam: '',
        achternaam: '',
        postcode: '',
        huisnummer: '',
        toevoeging: '',
        bedrijfsnaam: '',
        emailadres: '',
        telefoonnummer: '',
        huidigeProvider: '',
        hoeGehoord: '',
        internetDuur: '',
        bericht: ''
      },
      validated: false,
      loading: false
    };
  }

  updateField = (name: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    this.setState({
      contact: {
        ...this.state.contact,
        [name]: e.target.value
      }
    });
  }

  updateRadioField = (name: string, value: string) => {
    this.setState({
      contact: {
        ...this.state.contact,
        [name]: value
      }
    });
  }

  handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    event.stopPropagation();
    
    // Validate required fields
    const requiredFields = [
      'voornaam', 'achternaam', 'postcode', 'huisnummer',
      'emailadres', 'telefoonnummer', 'huidigeProvider'
    ];

    // Track invalid fields
    const invalidFields = requiredFields.filter(field =>
      this.state.contact[field]?.trim() === '' || this.state.contact[field] === undefined
    );

    // Also check the radio button fields
    if (this.state.contact.hoeGehoord.trim() === '') invalidFields.push('hoeGehoord');
    if (this.state.contact.internetDuur.trim() === '') invalidFields.push('internetDuur');

    if (invalidFields.length > 0) {
      console.log('Invalid fields:', invalidFields);
      this.setState({ validated: true });
      return;
    }

    // Store in session
    setWithExpiry('order', {
      ...this.sessionOrder,
      contact: this.state.contact,
    }, 7 * 60 * 60 * 1000); // 7 days

    this.setState({
      validated: true,
      loading: true
    });
    // Make API call
    console.log('send')
    api.requestOrder({
      selectedInternetProduct: 'undefined',
      selectedTvProduct: 'undefined',
      selectedPhoneProduct: 'undefined',
      selectedExtraProduct: 'undefined',
      contact: this.state.contact,
    })
      .then(() => {
        setWithExpiry('order', {}, 7 * 60 * 60 * 1000); // Clear session
        navigate('/offerte-aangevraagd');
      })
      .catch((e: any) => {
        alert("Er is iets foutgegaan bij het opsturen, probeer het alstublieft later nog eens");
      })
      .finally(() => {
        this.setState({
          loading: false
        });
      });
  }

  public render() {
    const video = this.props.data.file;

    return (
      <Layout>
        <Helmet>
          <style>{coreuiCss}</style>
        </Helmet>
        <ReactTooltip
          id="form"
          html={true}
        />
        <div
          css={mq({
            position: 'relative',
            paddingBottom: [18, null, 235],
            backgroundImage: `url('${backgroundImg}')`
          })}
        >
          <section
            css={mq({
              display: 'grid',
              gridTemplateColumns: ['1fr', '1fr', '1fr 1fr'],
              gap: 24,
              alignItems: 'end',
              position: 'relative',
              maxWidth: 1080,
              margin: '0 auto',
              zIndex: 1,
              paddingTop: 20,
              paddingLeft: 12,
              paddingRight: 12,
            })}
          >
            {/* Additional Content can go here */}
          </section>
          <BackgroundOverlay
            css={mq({
              position: 'absolute',
              left: 0,
              right: 0,
              top: 0,
              height: 660,
            })}
          >
            <BackgroundVideo
              css={mq({
                height: 660,
              })}
              posterUrl={video.videoScreenshots[0].publicURL}
              video={{
                H264: video.videoH264,
                H265: video.videoH265,
                VP9: video.videoVP9
              }}
            />
          </BackgroundOverlay>
          <div
            css={mq({
              paddingLeft: [6, 12, 24],
              paddingRight: [6, 12, 24],
            })}
          >
            <div
              css={{
                background: '#fff',
                position: 'relative',
                zIndex: 1,
                maxWidth: 1080,
                margin: '0 auto',
                marginTop: 32,
                boxShadow: '-2px 10px 41px -21px rgba(0,0,0,0.75)',
                paddingTop: 20,
                paddingBottom: 18,
              }}
            >

              <div
                css={(theme: any) => mq({
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: theme.colors.primary,
                  minHeight: 80,
                  marginLeft: [-6, null, -18],
                  marginRight: [-6, null, -18],
                  paddingLeft: 24,
                })}
              >
                <Text
                  onDark
                  size="xl"
                  css={{
                    fontWeight: 300
                  }}
                >
                  Start nu!
                </Text>
              </div>

              <div
                css={(theme: any) => mq({
                  padding: 16,
                  maxWidth: '100%',
                  width: '100%',
                  display: 'grid',
                  gridTemplateColumns: ['1fr', null, '1fr 1fr'],
                  gap: 24
                })}
              >
                {/* Full-width Banner */}
                <div
                  css={{
                    gridColumn: ['1 / -1', null, '1 / -1'],
                    marginBottom: 24
                  }}
                >
                  <img
                    src={Banner}
                    alt="Vodafone Ziggo Offer"
                    css={{
                      width: '100%',
                      height: 'auto',
                      objectFit: 'cover'
                    }}
                  />
                </div>

                {/* Left Column - Text */}
                <div>
                  <Text size="large" css={{ marginBottom: 12 }}>
                    Ontdek onze geweldige zakelijke aanbiedingen
                  </Text>
                  <Text size="regular" css={{ opacity: 0.8, marginBottom: 16 }}>
                    Bij ons ontvang je gratis en zonder verplichtingen advies. Ben je tevreden? Fantastisch! Dan nemen wij het verder van je over en zorgen we ervoor dat alles soepel verloopt. We garanderen je de beste korting, toegang tot het meest uitgebreide netwerk en altijd een gratis installatie.
                  </Text>
                  <div css={{ marginRight: 16 }}>
                    <Text size="small" css={{ marginTop: 4, marginRight: 10 }}>Bel ons</Text>
                    <Text size="regular" css={{ fontWeight: 'bold' }}>030-249 81 81</Text>
                  </div>
                  <div>
                    <Text size="small" css={{ marginTop: 4, marginRight: 10 }}>Mail ons</Text>
                    <Text size="regular" css={{ fontWeight: 'bold' }}>backoffice@smartsalescompany.nl</Text>
                  </div>
                </div>

                {/* Right Column - Form */}
                <div
                  css={{
                    background: '#f4f4f4',
                    padding: 24,
                    borderRadius: 8,
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                  }}
                >
                  <Text size="large" css={{ marginBottom: 12, textAlign: 'center' }}>
                    Vraag offerte aan
                  </Text>
                  <Text size="small" css={{ marginBottom: 16, textAlign: 'center' }}>
                    Wij nemen hierna telefonisch contact met u op om u te adviseren.
                  </Text>
                  <form
                    onSubmit={this.handleSubmit}
                    css={{
                      display: 'grid',
                      gap: '15px'
                    }}
                  >
                    {/* Input Fields */}
                    {[
                      { id: 'voornaam', label: 'Voornaam', required: true },
                      { id: 'achternaam', label: 'Achternaam', required: true },
                      { id: 'postcode', label: 'Uw Postcode', required: true },
                      { id: 'huisnummer', label: 'Huisnummer', required: true },
                      { id: 'toevoeging', label: 'Toevoeging', required: false },
                      { id: 'bedrijfsnaam', label: 'Bedrijfsnaam', required: false },
                      { id: 'emailadres', label: 'E-mail', type: 'email', required: true },
                      { id: 'telefoonnummer', label: 'Telefoonnummer', required: true, type: 'tel' },
                    ].map(({ id, label, type = 'text', required }) => (
                      <div key={id}>
                        <Text
                          size="small"
                          css={{
                            display: 'block',
                            marginBottom: '5px',
                            fontWeight: 'bold'
                          }}
                        >
                          {label}
                        </Text>
                        <input
                          type={type}
                          id={id}
                          name={id}
                          value={this.state.contact[id] || ''}
                          onChange={this.updateField(id)}
                          required={required}
                          css={{
                            width: '100%',
                            padding: '10px',
                            borderRadius: '4px',
                            border: '1px solid #ccc',
                            fontSize: 14
                          }}
                        />
                      </div>
                    ))}

                    {/* Select Dropdown */}
                    <div>
                      <Text
                        size="small"
                        css={{
                          display: 'block',
                          marginBottom: '5px',
                          fontWeight: 'bold'
                        }}
                      >
                        Huidige provider
                      </Text>
                      <select
                        id="huidigeProvider"
                        name="huidigeProvider"
                        value={this.state.contact.huidigeProvider}
                        onChange={(e) => this.updateRadioField('huidigeProvider', e.target.value)}
                        required
                        css={{
                          width: '100%',
                          padding: '10px',
                          borderRadius: '4px',
                          border: '1px solid #ccc',
                          fontSize: 14
                        }}
                      >
                        <option value="">Maak een keuze</option>
                        <option value="KPN">KPN</option>
                        <option value="Odido">Odido</option>
                        <option value="Delta">Delta</option>
                        <option value="Vodafone">Vodafone</option>
                        <option value="Ziggo">Ziggo</option>
                        <option value="Other">Anders</option>
                      </select>
                    </div>

                    {/* Radio Buttons */}
                    {['Hoe heb je ons gevonden?', 'Hoelang loopt uw huidige internet abonnement nog?'].map((label, idx) => {
                      const options = idx === 0 ? ['Facebook', 'TikTok', 'Ik ben telefonisch benaderd','Anders'] : ['korter dan 6 maanden', 'Langer dan 6 maanden', 'Ik heb geen lopend abonnement'];
                      const name = idx === 0 ? 'hoeGehoord' : 'internetDuur';
                      return (
                        <fieldset key={label} css={{ border: 'none', padding: 0, margin: 0 }}>
                          <Text size="small" css={{ fontWeight: 'bold', marginBottom: '5px' }}>{label}</Text>
                          {options.map(option => (
                            <div key={option} css={{ marginBottom: '5px' }}>
                              <input
                                type="radio"
                                id={option}
                                name={name}
                                value={option}
                                checked={this.state.contact[name] === option}
                                onChange={() => this.updateRadioField(name, option)}
                              />
                              <label htmlFor={option} css={{ marginLeft: '5px' }}>{option}</label>
                            </div>
                          ))}
                        </fieldset>
                      );
                    })}

                    <div css={{ marginTop: 16 }}>
                      <Button
                        type={EButtonType.WHITE}
                        disabled={this.state.loading}
                        css={{
                          width: '100%',
                          padding: '4px',
                          fontSize: 16,
                          backgroundColor: 'white',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: 'pointer'
                        }}
                      >
                        {this.state.loading ? 'Versturen...' : 'Offerte aanvragen'}
                      </Button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

export const query = graphql`
  query OfferteQuery1 {
    file(relativePath: { eq: "video/vodafone-video.mp4" }) {
      id
      name
      videoH264 {
        path
      }
      videoH265 {
        path
      }
      videoVP9 {
        path
      }
      videoScreenshots(timestamps: ["0", "1", "50%", "99%"]) {
        publicURL
      }
    }
  }
`;

export default CompanyFormPage;
